// frontend/src/pages/Dashboard/category-analytics/index.js

// src/pages/Dashboard/category-analytics/index.jsx
import React, { useState, useEffect } from 'react';
import styles from './CategoryAnalytics.module.css';
import { monthlySalesApi } from '../../../api/monthlysales/monthlySalesApi';
import MonthlyPivotTable from './components/MonthlyPivotTable';

const TABLE_TYPES = ['customer', 'salesperson', 'state', 'category'];

const CategoryAnalyticsPage = () => {
    const [categories, setCategories]       = useState([]);
    const [categoryFilters, setCategoryFilters] = useState({
        customer: '', salesperson: '', state: '', category: ''
    });
    const [data, setData] = useState({
        customer: [], salesperson: [], state: [], category: []
    });
    const [loading, setLoading] = useState({
        customer: false, salesperson: false, state: false, category: false
    });
    const [initialLoad, setInitialLoad] = useState(true);

    // Load categories
    useEffect(() => {
        monthlySalesApi.getCategories().then(setCategories).catch(console.error);
    }, []);

    // Initial data load
    useEffect(() => {
        const fetchAll = async () => {
            setInitialLoad(true);
            try {
                for (const type of TABLE_TYPES) {
                    setLoading(prev => ({ ...prev, [type]: true }));
                    const rows = await monthlySalesApi.getMonthlySales(type, null);
                    setData(prev => ({ ...prev, [type]: rows }));
                    setLoading(prev => ({ ...prev, [type]: false }));
                }
            } catch (err) {
                console.error('Error loading monthly data:', err);
            } finally {
                setInitialLoad(false);
            }
        };
        fetchAll();
    }, []);

    const handleCategoryFilterChange = async (type, category) => {
        setCategoryFilters(prev => ({ ...prev, [type]: category }));
        setLoading(prev => ({ ...prev, [type]: true }));
        try {
            const rows = await monthlySalesApi.getMonthlySales(type, category || null);
            setData(prev => ({ ...prev, [type]: rows }));
        } catch (err) {
            console.error('Filter error:', err);
        } finally {
            setLoading(prev => ({ ...prev, [type]: false }));
        }
    };

    const renderCategoryDropdown = (type) => (
        <div className={styles.filterRow}>
            <label className={styles.filterLabel}>Filter by Category:</label>
            <select
                className={styles.filterSelect}
                value={categoryFilters[type]}
                onChange={(e) => handleCategoryFilterChange(type, e.target.value)}
                disabled={initialLoad}
            >
                <option value="">All Categories</option>
                {categories.map((cat, i) => (
                    <option key={i} value={cat}>{cat}</option>
                ))}
            </select>
        </div>
    );

    if (initialLoad) {
        return (
            <div className={styles.page}>
                <div className={styles.loadingFull}>
                    <span className={styles.spinner} />
                    <span>Loading Sales Reports...</span>
                </div>
            </div>
        );
    }

    const sections = [
        { type: 'category',    title: 'Category-wise Monthly Sales' },
        { type: 'customer',    title: 'Customer-wise Monthly Sales' },
        { type: 'salesperson', title: 'Salesperson-wise Monthly Sales' },
        { type: 'state',       title: 'State-wise Monthly Sales' },
    ];

    return (
        <div className={styles.page}>
            <h1 className={styles.pageTitle}>Monthly Sales Analytics</h1>

            {sections.map(({ type, title }) => (
                <div key={type} className={styles.card}>
                    <div className={styles.cardHeader}>
                        <h2 className={styles.cardTitle}>{title}</h2>
                        {type !== 'category' && renderCategoryDropdown(type)}
                    </div>
                    <div className={styles.cardBody}>
                        {loading[type] ? (
                            <div className={styles.loading}>
                                <span className={styles.spinner} />
                                Loading...
                            </div>
                        ) : (
                            <MonthlyPivotTable
                                data={data[type]}
                                type={type}
                                categoryFilter={categoryFilters[type]}
                            />
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CategoryAnalyticsPage;